import { ListItemButton } from '@mui/material';
import { gridRowSelectionIdsSelector, useGridApiContext, useGridSelector } from '@mui/x-data-grid-pro';
import { useAppDispatch } from '@reduxStore';
import { queueModal } from '@components/Modals/modalSlice';

/**
 * Update Scheduled Pickup/Delivery Action List Item that opens the Update Scheduled Pickup/Delivery modal
 */
export default function UpdateScheduledPickupDeliveryAction() {
	const gridApiRef = useGridApiContext();
	const appDispatch = useAppDispatch();
	const selectedRowIds = useGridSelector(gridApiRef, gridRowSelectionIdsSelector);

	// This action requires at least 1 row to be selected
	if (selectedRowIds.size === 0) {
		return <></>;
	}

	const handleBtnClick = () => {
		appDispatch(
			queueModal({
				Component: 'updateScheduledPudlModal',
				Props: {
					legIds: Array.from(selectedRowIds.keys())
				}
			})
		);
	};

	return <ListItemButton onClick={handleBtnClick}>Update Scheduled Pickup/Delivery</ListItemButton>;
}
